var _linearGradient, _linearGradient2, _path, _linearGradient3, _path2, _linearGradient4, _path3, _linearGradient5, _path4, _linearGradient6, _path5, _linearGradient7, _path6, _linearGradient8, _path7, _linearGradient9, _path8, _linearGradient10, _path9, _linearGradient11, _path10, _linearGradient12, _path11, _linearGradient13, _path12, _linearGradient14, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaldo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6",
    gradientUnits: "userSpaceOnUse",
    x1: -1591.535,
    y1: -724.509,
    x2: -1590.535,
    y2: -724.509
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6",
    gradientUnits: "userSpaceOnUse",
    x1: 66.43,
    y1: 88.572,
    x2: 111.142,
    y2: 88.572
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M97.164 77.175H76.057L67.68 89.059l7.403-.584 5.066-5.066 25.717 16.561 4.026-5.78z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6",
    gradientUnits: "userSpaceOnUse",
    x1: 52.792,
    y1: 109.808,
    x2: 80.814,
    y2: 109.808
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M79.564 116.043l-3.02 4.091-22.502-15.683 3.215-4.968"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6",
    gradientUnits: "userSpaceOnUse",
    x1: 64.092,
    y1: 108.43,
    x2: 71.79,
    y2: 108.43
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M65.342 112.114l5.198-7.368"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6",
    gradientUnits: "userSpaceOnUse",
    x1: 58.375,
    y1: 104.678,
    x2: 66.074,
    y2: 104.678
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M59.625 108.362l5.199-7.368"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6",
    gradientUnits: "userSpaceOnUse",
    x1: 69.935,
    y1: 112.698,
    x2: 77.634,
    y2: 112.698
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M71.185 116.382l5.199-7.367"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6",
    gradientUnits: "userSpaceOnUse",
    x1: 90.101,
    y1: 102.753,
    x2: 104.778,
    y2: 102.753
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M91.351 98.912l12.177 7.682"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6",
    gradientUnits: "userSpaceOnUse",
    x1: 85.216,
    y1: 107.49,
    x2: 99.128,
    y2: 107.49
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_7_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M86.466 103.709l11.412 7.561"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6",
    gradientUnits: "userSpaceOnUse",
    x1: 80.49,
    y1: 112.285,
    x2: 93.283,
    y2: 112.285
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_8_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M81.74 108.82l10.293 6.931"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6",
    gradientUnits: "userSpaceOnUse",
    x1: 96.419,
    y1: 71.941,
    x2: 110.626,
    y2: 71.941
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_9_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M97.669 77.383l11.707-10.885"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6",
    gradientUnits: "userSpaceOnUse",
    x1: 109.025,
    y1: 87.798,
    x2: 125.96,
    y2: 87.798
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_10_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M110.275 93.579l14.435-11.563"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6",
    gradientUnits: "userSpaceOnUse",
    x1: 38.615,
    y1: 89.223,
    x2: 55.162,
    y2: 89.223
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_11_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M53.912 93.625l-14.047-8.804"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6",
    gradientUnits: "userSpaceOnUse",
    x1: 48.432,
    y1: 69.296,
    x2: 66.987,
    y2: 69.296
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_12_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M49.682 61.682L65.737 76.91"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6",
    gradientUnits: "userSpaceOnUse",
    x1: 52.662,
    y1: 98.703,
    x2: 110.428,
    y2: 98.703
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_13_8c45f40bb71dfb6667c121418eccfb2c6e8494ba1c24a886bfd1966679b1bdd6)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M86.773 120.232l-6.754-3.832-3.182-7.273-12.567-8.865-7.371-.877-2.987-5.585 12.209-16.625h9.547l-7.793 11.787 7.403-.487 4.871-4.968 25.717 16.658 3.312 2.532-22.405 17.535"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M127.501 68.592a49.515 49.515 0 014.481 20.651c0 27.447-22.25 49.698-49.698 49.698s-49.698-22.25-49.698-49.698 22.25-49.698 49.698-49.698c3.869 0 7.634.442 11.249 1.278"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M161.099 10.707h-52.756c-7.934 0-14.366 6.432-14.366 14.366v26.969c0 7.934 6.432 14.366 14.366 14.366h7.322l-4.669 11.089 20.426-11.089h29.676c7.934 0 14.366-6.432 14.366-14.366V25.073c.001-7.934-6.431-14.366-14.365-14.366z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M140.629 33.081s-1.023-5.919-5.919-5.919-6.212 5.919-6.212 5.919l12.716 9.641M129.082 42.722s1.023 5.919 5.919 5.919 6.212-5.919 6.212-5.919M134.855 22.119v5.043M134.855 48.642v5.042"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M140.629 33.081s-1.023-5.919-5.919-5.919-6.212 5.919-6.212 5.919l12.716 9.641M129.082 42.722s1.023 5.919 5.919 5.919 6.212-5.919 6.212-5.919M134.855 22.119v5.043M134.855 48.642v5.042"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M122.362 72.522a43.217 43.217 0 013.4 16.857c0 23.938-19.405 43.343-43.343 43.343s-43.343-19.405-43.343-43.343 19.405-43.343 43.343-43.343c3.776 0 7.44.483 10.932 1.391"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaldo);
export default __webpack_public_path__ + "static/media/saldo.5605e605218f0482a3b58c6a09b66307.svg";
export { ForwardRef as ReactComponent };